import packageJson from "../package.json";

export const APP_META = {
  name: "BluePulse",
  version: packageJson.version,
  lastUpdated: "2026-07-06",
} as const;
